import React, { useEffect, useRef, useState } from 'react';
import {ClientsScreen} from '../screens/clients/ui/screens/ClientsScreen';
export default function ClientsConfiguration() {

    return (
        <div>
           <ClientsScreen></ClientsScreen>
        </div>
    );
}